import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeTree: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="code-tree, file-tree"><path d="M4.75 3C5.16421 3 5.5 3.33579 5.5 3.75V9H13.082C13.4255 7.42756 14.8246 6.25 16.5 6.25C18.433 6.25 20 7.817 20 9.75C20 11.683 18.433 13.25 16.5 13.25C14.8246 13.25 13.4255 12.0724 13.082 10.5H5.5V17H13.082C13.4255 15.4276 14.8246 14.25 16.5 14.25C18.433 14.25 20 15.817 20 17.75C20 19.683 18.433 21.25 16.5 21.25C14.8246 21.25 13.4255 20.0724 13.082 18.5H4.75C4.33579 18.5 4 18.1642 4 17.75V3.75C4 3.33579 4.33579 3 4.75 3Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCodeTree;
